import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class DownloadService {

  constructor(
    private http: HttpClient
  ) { }

  download(url: string): Observable<boolean> {
    return this.http.get(url, {observe: 'response', responseType: 'blob'}).pipe(
      switchMap(data => {
        return this.downloadFile(data, url);
      }),

      catchError(error => {
        console.error(error);
        return of(false);
      })
    );
  }

  private downloadFile(result: any, url: string): Observable<boolean> {

    try {

      // get filename from response headers:
      let filename = '';
      const disposition: any = result.headers.get('content-disposition');
      if (disposition && disposition.indexOf('attachment') !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['']).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['']/g, '');
        }
        filename = filename.replace(new RegExp('"', 'g'), '');
      }

      // create URL for blob:
      const URL = window.URL || window['webkitURL'];
      const downloadUrl = URL.createObjectURL(new Blob([result.body]));

      // create anchor element:
      const a = document.createElement('a');

      /**
       * If anchor download is supported by browser, create virtual anchor tag with url to the blob,
       * otherwise, just navigate to url.
       */
      if (typeof a.download === 'undefined') {
        window.location.href = url;

      } else {
        a.href = downloadUrl;
        a.setAttribute('download', filename);

        // create and attach attributes:
        const attr = document.createAttribute('aria-label');
        attr.value = filename;
        a.setAttributeNode(attr);

        // attach anchor element to body and click to execute:
        document.body.appendChild(a);
        a.click();

        // destroy URL:
        setTimeout(function () { URL.revokeObjectURL(downloadUrl); }, 10);
      }
      return of(true);

    } catch (error) {
      return of(false);

    }
  }
}
